// extracted by mini-css-extract-plugin
export default {"widgetTable":"ChartRenderer_widgetTable__u1Z4O"};